import { Customer, InputRuleApiModel, RequiredIfModel } from '~/lib/api/smartsend/types';
import sanitiseValue from '~/lib/utils/value-sanitiser';

const conditionalIsRequired = (
  m: InputRuleApiModel,
  primaryCustomerType: 'Sender' | 'Recipient',
  customer: Customer,
  secondaryCustomer?: Customer
) => {
  if (!m?.dataRequiredIf) {
    return undefined;
  }

  let output = undefined;

  const conditional =
    typeof m.dataRequiredIf === 'string' ? (JSON.parse(m.dataRequiredIf) as RequiredIfModel) : m.dataRequiredIf;

  conditional?.All?.forEach((c) => {
    // Field includes Sender or Recipient explicitly.
    const model = (() => {
      if (c.Field?.includes('.')) {
        return c.Field.split('.')[0];
      } else {
        return primaryCustomerType;
      }
    })();

    const customerToUse = model === primaryCustomerType ? customer : secondaryCustomer;

    if (!customerToUse) {
      return (output = false);
    }

    const field = c.Field?.includes('.') ? c.Field.split('.')[1] : c.Field;

    const fieldToCheckValue: string = customerToUse.Meta[field]
      ? customerToUse.Meta[field]?.Value
      : customerToUse[field];

    if (sanitiseValue(fieldToCheckValue) === sanitiseValue(c.Value)) {
      output = true;
    }
  });

  return output;
};

export default conditionalIsRequired;
